export interface RemplazosMMax {
    modo: string,
    nombre: string,
    idcss?: string;
    activo?: boolean;
}